import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=2386ed09&scoped=true"
import script from "./explain.vue?vue&type=script&lang=js"
export * from "./explain.vue?vue&type=script&lang=js"
import style0 from "./explain.vue?vue&type=style&index=0&id=2386ed09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2386ed09",
  null
  
)

export default component.exports